import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-128" data-mp="kzvf3jsbaucg">
      <div className="box-border w-full max-w-full overflow-hidden border-b border-slate-200 bg-slate-100 py-1.5 text-slate-600" data-id="element-129" data-mp="zwctykzpmr3r">
        <div className="mx-auto w-full max-w-full box-border whitespace-normal break-words px-3 text-center text-[12px] font-medium leading-tight sm:px-4 sm:text-xs xl:text-[13px]" data-id="element-130" data-mp="uz2yanlq9j7h">
          <span className="block sm:inline" data-id="element-131" data-mp="2b70ffkf9l94">
            Medical modality equipment, training &amp; support
          </span>
          <span className="hidden sm:inline" data-id="element-132" data-mp="h0mmii90d2ih"> </span>
          <span className="block sm:inline" data-id="element-133" data-mp="c6s89uc69fqs">
            for chiropractic, rehab &amp; wellness practices.
          </span>
        </div>
      </div>
      <Header data-id="element-134" data-mp="3klaahfffm12h" />
      <main className="flex-1" data-id="element-135" data-mp="3fojyb36qzpmc">{children}</main>
      <Footer data-id="element-136" data-mp="3fnqxeiugzuc4" />
    </div>;
}